import { render } from "./ConsumptionDetail.vue?vue&type=template&id=07218319&scoped=true"
import script from "./ConsumptionDetail.vue?vue&type=script&lang=js"
export * from "./ConsumptionDetail.vue?vue&type=script&lang=js"

import "./ConsumptionDetail.vue?vue&type=style&index=0&id=07218319&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07218319"]])

export default __exports__